import Vue from 'vue'
import VueCookies from 'vue-cookies';

const DOMAIN_NAME = '.blackdevs.com.br';

Vue.use(VueCookies, { expire: '7d' });

const setUserLanguage = (language) => {
  // using cookie SameSite=Lax
  Vue.$cookies.set('language', language, '7d', null, DOMAIN_NAME, true, 'Lax');
};

const getUserLanguage = () => {
  let browserLanguage = navigator.language || navigator.userLanguage;
  browserLanguage = browserLanguage.toLowerCase()
  if (!['en-us', 'pt-br'].includes(browserLanguage)) {
    browserLanguage = 'pt-br';
  }
  const language = Vue.$cookies.get('language');
  if (!language || !['en-us', 'pt-br'].includes(language)) {
    return browserLanguage;
  }
  return language;
};

const setShowCookiesPolicy = (showCookiesPolicy) => {
  // using cookie SameSite=Lax
  Vue.$cookies.set('show_cookies_policy', showCookiesPolicy === true, '7d', null, DOMAIN_NAME, true, 'Lax');
};

const getShowCookiesPolicy = () => {
  const showCookiesPolicy = Vue.$cookies.get('show_cookies_policy');
  return showCookiesPolicy != undefined ? (showCookiesPolicy === true) : true;
};

export {
  setUserLanguage,
  getUserLanguage,
  setShowCookiesPolicy,
  getShowCookiesPolicy,
};
